import { bool, func, number, oneOf, string } from 'prop-types'
import { kuiperClassNames, Loader } from '@opallabs/kuiper'
import { Button, Tooltip } from '@opallabs/lapidary'
import { track } from '@opallabs/quanta'
import { isInWorkflowPopover } from '../../helpers/matchers'
import { getLoaderTheme } from '../helpers/items'

import './styles.scss'

const popoverMessage =
  'Workflow can be started once an account is selected and at least one phase is created.'

const buttonLabel = (hasPreStartFunction) =>
  hasPreStartFunction ? 'Save Content And Start Workflow' : 'Start Workflow'

const startWorkflow = (
  preStartFunction,
  otherProps,
  callback,
  workflowLocation
) => {
  track('Workflow: Start', {
    contentId: otherProps.workflow.content.id,
    workflowPopover: isInWorkflowPopover(workflowLocation),
  })

  otherProps.setLoader({ startingWorkflow: true })

  if (preStartFunction) {
    preStartFunction()
    return callback()
  }
  return callback()
}

const shouldDisableStart = (contentAccountId, isLimitedRole, workflowValid) => {
  if (isLimitedRole) {
    return true
  }
  if (workflowValid) {
    return !contentAccountId
  }
  return true
}

const WorkflowStarter = ({
  contentAccountId,
  entitySaveMethod,
  isLimitedRole,
  onStartWorkflow,
  theme,
  workflowLocation,
  workflowValid,
  ...otherProps
}) => {
  const disableStart = shouldDisableStart(
    contentAccountId,
    isLimitedRole,
    workflowValid
  )

  return (
    <div
      className={kuiperClassNames('workflowStarter', {
        inWorkflowPopover: isInWorkflowPopover(workflowLocation),
      })}
    >
      <Tooltip
        disabled={workflowValid}
        type="description"
        size="small"
        text={popoverMessage}
        theme="light"
      >
        <div className={kuiperClassNames('button-container')}>
          <Button
            aria-disabled={disableStart}
            variant="primary"
            buttonText={buttonLabel(entitySaveMethod)}
            hideButtonText={otherProps.loaders.startingWorkflow}
            onClick={
              disableStart
                ? undefined
                : () => {
                    startWorkflow(
                      entitySaveMethod,
                      otherProps,
                      onStartWorkflow,
                      workflowLocation
                    )
                  }
            }
            styleOverrides={
              disableStart ? { button: { opacity: 0.5 } } : undefined
            }
            {...{
              theme,
            }}
          />
        </div>
      </Tooltip>
      <Loader
        loaded={!otherProps.loaders.startingWorkflow}
        theme={getLoaderTheme({ isTemplate: false, workflowLocation })}
      />
    </div>
  )
}

WorkflowStarter.propTypes = {
  contentAccountId: number,
  entitySaveMethod: func,
  isLimitedRole: bool,
  onStartWorkflow: func.isRequired,
  theme: oneOf(['dark', 'light']),
  workflowLocation: string,
  workflowValid: bool,
}

export default WorkflowStarter
